<app-header></app-header>

<div class="p-4">

  <!-- En-tête -->
  <div class="flex items-center gap-3 mb-5 pl-3 border-l-4 border-ag-red">
    <div>
      <h2 class="text-lg font-bold text-gray-900 m-0">Gestion des absences</h2>
      <p class="text-xs text-gray-400 m-0">Suivi des absences, retards et arrêts maladie du personnel</p>
    </div>
  </div>

  <!-- Carte tableau -->
  <div class="rounded-xl border border-gray-100 bg-white shadow-sm overflow-hidden">

    <!-- Barre d'outils -->
    <div class="flex flex-wrap items-center gap-2 px-4 py-3 border-b border-gray-100 bg-gray-50">
      @if (buttonsPermission?.add) {
        <button (click)="add(formContent)"
                class="inline-flex items-center gap-1 px-3 py-1.5 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold transition-colors">
          + Nouvelle absence
        </button>
      }
      @if (selected_data && buttonsPermission?.edit) {
        <button (click)="edit(formContent)"
                class="px-3 py-1.5 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm transition-colors">
          Modifier
        </button>
      }
      @if (selected_data && buttonsPermission?.delete) {
        <button (click)="delete()"
                class="px-3 py-1.5 rounded-lg border border-ag-red text-ag-red hover:bg-ag-red hover:text-white text-sm transition-colors">
          Supprimer
        </button>
      }
      <div class="ml-auto">
        <input type="text" [(ngModel)]="search_text" placeholder="Rechercher..."
               class="border border-gray-200 rounded-lg px-3 py-1.5 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10 w-56">
      </div>
    </div>

    <app-loading [isVisible]="loading"></app-loading>

    <!-- Tableau -->
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="bg-gray-50 text-start text-xs text-gray-400 uppercase tracking-wide">
            <th class="px-3 py-2 w-8"></th>
            <th class="px-3 py-2">Employé</th>
            <th class="px-3 py-2">Date</th>
            <th class="px-3 py-2">Type</th>
            <th class="px-3 py-2">Motif</th>
            <th class="px-3 py-2 text-center">Justifiée</th>
          </tr>
        </thead>
        <tbody>
          @for (d of data | sampleSearch:search_text:'reason' | paginate:{id:'absPg', itemsPerPage:pg.pageSize, currentPage:pg.p, totalItems:pg.total}; track d.id) {
            <tr class="border-t border-gray-50 hover:bg-red-50/30 transition-colors">
              <td class="px-3 py-2"><input type="radio" [checked]="selected_data?.id === d.id" name="absRadio" (click)="checked(d)" class="accent-ag-red"></td>
              <td class="px-3 py-2 font-semibold text-gray-800">{{personalName(d.personal)}}</td>
              <td class="px-3 py-2 text-gray-500">
                {{d.date | date:'dd/MM/yyyy'}}
                @if (d.end_date) { <span class="text-gray-400"> → {{d.end_date | date:'dd/MM/yyyy'}}</span> }
              </td>
              <td class="px-3 py-2">
                <span class="px-2 py-0.5 rounded-full text-xs font-semibold" [ngClass]="typeClass(d.type)">{{typeLabel(d.type)}}</span>
              </td>
              <td class="px-3 py-2 text-gray-600">{{d.reason || '—'}}</td>
              <td class="px-3 py-2 text-center">
                @if (d.is_justified) {
                  <span class="px-2 py-0.5 rounded-full bg-green-100 text-green-700 text-xs font-semibold">Oui</span>
                } @else {
                  <span class="px-2 py-0.5 rounded-full bg-gray-100 text-gray-500 text-xs font-semibold">Non</span>
                }
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    @if (!loading && data.length === 0) {
      <p class="text-center text-gray-400 py-8 text-sm">Aucune absence enregistrée.</p>
    }

    <div class="flex justify-center py-3">
      <pagination-controls id="absPg" (pageChange)="getPage($event)"
                           [previousLabel]="'Précédent'" [nextLabel]="'Suivant'" [autoHide]="true">
      </pagination-controls>
    </div>
  </div>
</div>

<!-- Modal formulaire -->
<ng-template #formContent let-c="close" let-d="dismiss">
  <div class="flex items-center justify-between px-5 py-3 border-b border-gray-100 border-l-4 border-l-ag-red">
    <h5 class="font-bold text-gray-900 m-0">{{form.id ? 'Modifier' : 'Nouvelle'}} absence</h5>
    <button type="button" (click)="d('x')" class="w-7 h-7 rounded-full hover:bg-gray-100 text-gray-400">✕</button>
  </div>
  <form #f="ngForm" (ngSubmit)="form.id ? update(form) : store(form)">
    <div class="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Employé *</label>
        <select name="personal_id" [(ngModel)]="form.personal_id" required
                class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          <option [ngValue]="null">— Choisir —</option>
          @for (p of personals; track p.id) { <option [ngValue]="p.id">{{p.lastname}} {{p.firstname}}</option> }
        </select>
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Date de début *</label>
        <input name="date" type="date" [(ngModel)]="form.date" required
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Date de fin</label>
        <input name="end_date" type="date" [(ngModel)]="form.end_date"
               class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
      </div>
      <div>
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Type *</label>
        <select name="type" [(ngModel)]="form.type" required
                class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red">
          @for (t of TYPES; track t) { <option [value]="t">{{typeLabel(t)}}</option> }
        </select>
      </div>
      <div class="flex items-end pb-2">
        <label class="inline-flex items-center gap-2 text-sm text-gray-700">
          <input name="is_justified" type="checkbox" [(ngModel)]="form.is_justified" class="accent-ag-red w-4 h-4">
          Absence justifiée
        </label>
      </div>
      <div class="md:col-span-2">
        <label class="block text-xs font-semibold text-gray-600 uppercase mb-1">Motif</label>
        <textarea name="reason" rows="2" [(ngModel)]="form.reason"
                  class="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm outline-none focus:border-ag-red focus:ring-2 focus:ring-ag-red/10"></textarea>
      </div>
    </div>
    <div class="flex justify-end gap-2 px-5 py-3 border-t border-gray-100 bg-gray-50">
      <button type="button" (click)="d('x')" class="px-4 py-2 rounded-lg border border-gray-300 text-gray-600 hover:bg-gray-100 text-sm">Annuler</button>
      <button type="submit" [disabled]="f.invalid || loading"
              class="px-4 py-2 rounded-lg bg-ag-red hover:bg-ag-red-alt text-white text-sm font-semibold disabled:opacity-50 inline-flex items-center gap-2">
        Enregistrer <app-loading [isVisible]="loading"></app-loading>
      </button>
    </div>
  </form>
</ng-template>
